import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Правила и условия",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Title} = _components;
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Правила и условия"
    }), "\n", _jsx(_components.p, {
      children: "Группа Всемирного доклада по мониторингу образования поощряет использование сайта «Scoping Progress in Education (SCOPE)» только в информационных целях. Все содержание данного сайта защищено авторским правом. Получая доступ к сайту и используя любой размещенный на нем контент, вы («Пользователь») признаете, что полностью прочитали и поняли настоящие Условия пользования и согласны с ними."
    }), "\n", _jsx(_components.p, {
      children: "Размещенная на этом сайте информация предназначена для личного или общественного некоммерческого использования и может воспроизводиться частично или полностью любым способом без взимания платы или дополнительного разрешения, если не указано иное. Все заявки на коммерческое использование и права на перевод следует направлять по адресу gemreport@unesco.org"
    }), "\n", _jsx(_components.h2, {
      id: "пользователи-обязаны",
      children: "Пользователи обязаны:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Проявлять должную осмотрительность для обеспечения точности воспроизведенных материалов;"
      }), "\n", _jsx(_components.li, {
        children: "Указывать источник на видном месте рядом с данными, используя следующий формат:\nИсточник: (При необходимости «Адаптировано на основе») доклад ВДМО Scoping Progress in Education (SCOPE), https://www.education-progress.org, дата отбора цитаты."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Следует отметить, что база данных регулярно обновляется и пересматривается. Поэтому при цитировании данных важно указывать дату их отбора."
    }), "\n", _jsx(_components.h2, {
      id: "лицензии",
      children: "Лицензии"
    }), "\n", _jsx(_components.p, {
      children: "Мы призываем вас творчески использовать эти данные в своих и общественных интересах. Вы можете извлекать, загружать и копировать содержащуюся в наборах данных информацию, а также передавать ее третьим лицам."
    }), "\n", _jsx(_components.h2, {
      id: "отсутствие-ассоциирования-или-одобрения",
      children: "Отсутствие ассоциирования или одобрения"
    }), "\n", _jsx(_components.p, {
      children: "Пользователь не может утверждать или подразумевать, что группа Всемирного доклада по мониторингу образования участвовала в подготовке, утверждении, одобрении или иной поддержке использования или воспроизведения им материалов. Пользователь не может претендовать на какую-либо связь с сайтом «Прогресс в области образования» (или Всемирным докладом по мониторингу образования)."
    }), "\n", _jsx(_components.h2, {
      id: "ссылки-на-сайт",
      children: "Ссылки на сайт"
    }), "\n", _jsx(_components.p, {
      children: "Внешний сайт может включать гиперссылку на любую страницу сайта «SCOPE» без получения разрешения. Однако это не должно нарушать прав интеллектуальной собственности, предусмотренных во Всемирном докладе по мониторингу образования, в частности в том, что касается названий, логотипов, авторского права или авторских прав."
    }), "\n", _jsx(_components.h2, {
      id: "ограничение-ответственности",
      children: "Ограничение ответственности"
    }), "\n", _jsx(_components.p, {
      children: "Группа Всемирного доклада по мониторингу образования поддерживает этот сайт в целях расширения доступа общественности к данным и соответствующей информации. Она прилагает все усилия для обеспечения точности и полноты информации на этом сайте, но не гарантирует этого. Наша цель заключается в обеспечении своевременности и точности этой информации. Если до нас дойдет информация об ошибках, мы постараемся их исправить."
    }), "\n", _jsx(_components.p, {
      children: "Использованные на настоящем сайте названия и представление материала не являются выражением со стороны ЮНЕСКО какого-либо мнения относительно правового статуса какой-либо страны, территории, города или района или их соответствующих органов управления, равно как и линий их разграничения или границ."
    }), "\n", _jsx(_components.p, {
      children: "Группа Всемирного доклада по мониторингу образования несет ответственность за выбор и изложение на настоящем сайте фактов, которые могут не совпадать с позицией ЮНЕСКО и ни к чему ее не обязывают."
    }), "\n", _jsx(_components.p, {
      children: "Мы стремимся свести к минимуму последствия, вызванные техническими сбоями. Тем не менее некоторые данные или информация на сайте могут быть созданы или структурированы в файлах или форматах, которые не обеспечивают абсолютной технической надежности, и мы не можем гарантировать, что наши услуги не будут прерваны или иным образом затронуты такими проблемами. Группа Всемирного доклада по мониторингу образования не несет ответственности в связи с такими проблемами (сбой в работе, компьютерный вирус, сбой линии связи, изменение содержания и т.д.), возникшими в результате использования сайта «SCOPE» или какой-либо ссылки на внешние сайты."
    }), "\n", _jsx(_components.h2, {
      id: "неприкосновенность-личной-жизни",
      children: "Неприкосновенность личной жизни"
    }), "\n", _jsx(_components.p, {
      children: "При посещении сайта «SCOPE» на наших серверах будет сохраняться определенная информация, такая как адреса интернет-протокола (IP), поведение при навигации по сайту, используемое программное обеспечение и проведенное на сайте время, а также другая аналогичная информация. Эта информация не идентифицирует Вас лично и будет использоваться для анализа посещаемости сайта."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
